import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"]
  static values = { offset: { type: Number, default: 80 } }

  connect() {
    this.links = this.linkTargets.map((link) => {
      const hash = link.getAttribute("href") || ""
      const section = hash.length > 1 ? document.getElementById(hash.slice(1)) : null
      return { link, section }
    })
    this.defaultLink = (this.links.find((entry) => !entry.section) || this.links[0])?.link

    this.pastOffset = new Map()

    this.observer = new IntersectionObserver((entries) => this.handleIntersect(entries), {
      rootMargin: `-${this.offsetValue}px 0px -${100 - this.offsetValue / window.innerHeight * 100}% 0px`
    })
    this.links.forEach(({ section }) => section && this.observer.observe(section))

    this.updateActiveLink()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  activate(event) {
    this.setActiveLink(event.currentTarget)
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      this.pastOffset.set(entry.target, entry.boundingClientRect.top <= this.offsetValue)
    })

    this.updateActiveLink()
  }

  updateActiveLink() {
    let current = this.defaultLink

    this.links.forEach(({ link, section }) => {
      if (section && this.pastOffset.get(section)) {
        current = link
      }
    })

    this.setActiveLink(current)
  }

  setActiveLink(activeLink) {
    this.linkTargets.forEach((link) => {
      if (link === activeLink) {
        link.setAttribute("aria-current", "page")
      } else {
        link.removeAttribute("aria-current")
      }
    })
  }

  syncLinks(event) {
    const hiddenGroupIds = new Set(event.detail.hiddenGroupIds)

    this.links.forEach(({ link, section }) => {
      const disabled = !!section && hiddenGroupIds.has(section.id)

      if (disabled) {
        link.setAttribute("aria-disabled", "true")
      } else {
        link.removeAttribute("aria-disabled")
      }
    })
  }
}
